import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100% !important",
    paddingTop: "5px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "black",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.background.default,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.background.default,
    },
  },
}));

export default function AutoCompleteComponent({
  dropdownItems,
  propertyName,
  label,
  onChange,
  selectOption,
  currValue,
  id = null,
}: {
  dropdownItems: any[];
  propertyName: string;
  label: string;
  onChange: (event: any, value: any) => void;
  selectOption?: (option: any, value: any) => boolean;
  currValue: any;
  id?: string | null;
}) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Autocomplete
      value={currValue}
      className={classes.root}
      options={dropdownItems}
      getOptionLabel={(option) => option[propertyName]}
      getOptionSelected={selectOption}
      style={{ width: 300 }}
      onChange={onChange}
      id={id ?? undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputLabelProps={{ style: { color: theme.palette.primary.main } }}
        />
      )}
    />
  );
}
